var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotLogoLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#5B73E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1601 14.4571C19.8851 14.4571 19.6621 14.2341 19.6621 13.959V9.31055C19.6621 9.03549 19.8851 8.8125 20.1601 8.8125C20.4352 8.8125 20.6582 9.03549 20.6582 9.31055V13.959C20.6582 14.2341 20.4352 14.4571 20.1601 14.4571Z",
    fill: "#00347B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83788 14.4571C8.56283 14.4571 8.33984 14.2341 8.33984 13.959V9.31055C8.33984 9.03549 8.56283 8.8125 8.83788 8.8125C9.11293 8.8125 9.33592 9.03549 9.33592 9.31055V13.959C9.33592 14.2341 9.11293 14.4571 8.83788 14.4571Z",
    fill: "#00429D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9118 21.713H17.8203C17.5453 21.713 17.3223 21.49 17.3223 21.2149C17.3223 20.9399 17.5453 20.7169 17.8203 20.7169H19.9118C21.0459 20.7169 22.0041 19.7817 22.0041 18.6748V15.0889C22.0041 14.8138 22.2271 14.5908 22.5021 14.5908C22.7772 14.5908 23.0002 14.8138 23.0002 15.0889V18.6748C23.0002 20.3216 21.5859 21.713 19.9118 21.713Z",
    fill: "#00429D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28706 12.1909H7.49412C6.67026 12.1909 6 12.8612 6 13.6851V15.7105C6 16.5344 6.67026 17.2047 7.49412 17.2047H9.28706C9.56211 17.2047 9.7851 16.9817 9.7851 16.7066V12.689C9.7851 12.4139 9.56211 12.1909 9.28706 12.1909Z",
    fill: "#4793FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5058 12.1909H19.7129C19.4378 12.1909 19.2148 12.4139 19.2148 12.689V16.7066C19.2148 16.9817 19.4378 17.2047 19.7129 17.2047H21.5058C22.3297 17.2047 22.9999 16.5344 22.9999 15.7105V13.6851C22.9999 12.8612 22.3297 12.1909 21.5058 12.1909Z",
    fill: "#525CDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0959 9.86604C17.8715 8.66271 16.2393 8 14.4999 8C12.7593 8 11.1265 8.66278 9.90257 9.86627C8.67065 11.0776 7.99219 12.7024 7.99219 14.4416V15.4043C7.99219 17.2169 9.46682 18.6915 11.2794 18.6915H17.7205C19.533 18.6915 21.0076 17.2169 21.0076 15.4043V14.4416C21.0076 12.7026 20.3287 11.0777 19.0959 9.86604Z",
    fill: "#F0F5FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0959 9.86604C17.8716 8.66271 16.2394 8 14.5 8V18.6915H17.7206C19.5331 18.6915 21.0077 17.2169 21.0077 15.4043V14.4416C21.0077 12.7026 20.3288 11.0777 19.0959 9.86604Z",
    fill: "#D7E3F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5419 11.2539H12.458C10.8194 11.2539 9.48633 12.587 9.48633 14.2256C9.48633 15.8642 10.8194 17.1973 12.458 17.1973H16.5419C18.1804 17.1973 19.5135 15.8642 19.5135 14.2256C19.5135 12.587 18.1804 11.2539 16.5419 11.2539Z",
    fill: "#D7E3F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.542 11.2539H14.5V17.1973H16.542C18.1805 17.1973 19.5136 15.8642 19.5136 14.2256C19.5136 12.587 18.1805 11.2539 16.542 11.2539Z",
    fill: "#A0B6DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5419 12.2505H12.458C11.3714 12.2505 10.4824 13.1395 10.4824 14.2261C10.4824 15.3127 11.3714 16.2017 12.458 16.2017H16.5419C17.6285 16.2017 18.5175 15.3127 18.5175 14.2261C18.5175 13.1395 17.6285 12.2505 16.5419 12.2505Z",
    fill: "#00429D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.542 12.25H14.5V16.2012H16.542C17.6285 16.2012 18.5175 15.3122 18.5175 14.2256C18.5175 13.139 17.6285 12.25 16.542 12.25Z",
    fill: "#00347B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5703 14.9063C12.2953 14.9063 12.0723 14.6833 12.0723 14.4082V14.043C12.0723 13.7679 12.2953 13.5449 12.5703 13.5449C12.8454 13.5449 13.0683 13.7679 13.0683 14.043V14.4082C13.0683 14.6833 12.8454 14.9063 12.5703 14.9063Z",
    fill: "#4793FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4316 14.9063C16.1566 14.9063 15.9336 14.6833 15.9336 14.4082V14.043C15.9336 13.7679 16.1566 13.5449 16.4316 13.5449C16.7067 13.5449 16.9297 13.7679 16.9297 14.043V14.4082C16.9297 14.6833 16.7067 14.9063 16.4316 14.9063Z",
    fill: "#525CDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0908 19.9365H15.9951C15.3085 19.9365 14.75 20.4951 14.75 21.1817C14.75 21.8682 15.3085 22.4268 15.9951 22.4268H17.0908C17.7774 22.4268 18.3359 21.8682 18.3359 21.1817C18.3359 20.4951 17.7774 19.9365 17.0908 19.9365Z",
    fill: "#00347B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotLogoLive);
export default __webpack_public_path__ + "static/media/bot-logo-live.a9f0a0957ce3247031d8763575168b8f.svg";
export { ForwardRef as ReactComponent };